import { classNames } from "./classNames.js";
export const bulma = (...args) => classNames(...args);
